import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
export const Search20 = (props)=>/*#__PURE__*/ _jsx("svg", _object_spread_props(_object_spread({
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: /*#__PURE__*/ _jsx("path", {
            d: "M13.1538 13.1538L17.5 17.5M14.7929 8.64647C14.7929 12.0411 12.0411 14.7929 8.64647 14.7929C5.25187 14.7929 2.5 12.0411 2.5 8.64647C2.5 5.25187 5.25187 2.5 8.64647 2.5C12.0411 2.5 14.7929 5.25187 14.7929 8.64647Z",
            stroke: "currentColor",
            strokeWidth: "1.33",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    }));
